export type BasicSettingField = {
  type: 'input'|'autosize-input'|'country-select'
  section: 'company'|'address'|'other'
  props: {
    placeholder: string
    label: string
    name: string
    type?: 'text'|'email'
  }
}

const settingsData : BasicSettingField[] = [
  {
    type: 'autosize-input',
    section: 'company',
    props: {
      placeholder: 'configuration.basic.name',
      label: 'configuration.basic.name',
      name: 'name',
    },
  },
  {
    type: 'input',
    section: 'company',
    props: {
      placeholder: 'configuration.basic.legalStatus',
      label: 'configuration.basic.legalStatus',
      name: 'legalStatus',
    },
  },
  {
    type: 'input',
    section: 'address',
    props: {
      placeholder: 'configuration.basic.street',
      label: 'configuration.basic.street',
      name: 'street',
    },
  },
  {
    type: 'input',
    section: 'address',
    props: {
      placeholder: 'configuration.basic.buildingNumber',
      label: 'configuration.basic.buildingNumber',
      name: 'buildingNumber',
    },
  },
  {
    type: 'input',
    section: 'address',
    props: {
      placeholder: 'configuration.basic.flatNumber',
      label: 'configuration.basic.flatNumber',
      name: 'flatNumber',
    },
  },
  {
    type: 'input',
    section: 'address',
    props: {
      placeholder: 'configuration.basic.city',
      label: 'configuration.basic.city',
      name: 'city',
    },
  },
  {
    type: 'input',
    section: 'address',
    props: {
      placeholder: 'configuration.basic.postalCode',
      label: 'configuration.basic.postalCode',
      name: 'postalCode',
    },
  },
  {
    type: 'input',
    section: 'address',
    props: {
      placeholder: 'configuration.basic.post',
      label: 'configuration.basic.post',
      name: 'post',
    },
  },
  {
    type: 'country-select',
    section: 'address',
    props: {
      placeholder: 'newDelegation.accomodation.choose-country', //TODO translation
      label: 'configuration.basic.country',
      name: 'country',
    },
  },
  {
    type: 'input',
    section: 'company',
    props: {
      placeholder: 'configuration.basic.nip',
      label: 'configuration.basic.nip',
      name: 'nip',
    },
  },
  {
    type: 'input',
    section: 'company',
    props: {
      placeholder: 'configuration.basic.regon',
      label: 'configuration.basic.regon',
      name: 'regon',
    },
  },
  {
    type: 'input',
    section: 'company',
    props: {
      placeholder: 'configuration.basic.krs',
      label: 'configuration.basic.krs',
      name: 'krs',
    },
  },
  {
    type: 'input',
    section: 'other',
    props: {
      placeholder: 'configuration.basic.officePhone',
      label: 'configuration.basic.officePhone',
      name: 'officePhone',
    },
  },
  {
    type: 'input',
    section: 'other',
    props: {
      placeholder: 'configuration.basic.mobile',
      label: 'configuration.basic.mobile',
      name: 'mobile',
    },
  },
  {
    type: 'input',
    section: 'other',
    props: {
      placeholder: 'configuration.basic.fax',
      label: 'configuration.basic.fax',
      name: 'fax',
    },
  },
  {
    type: 'input',
    section: 'other',
    props: {
      placeholder: 'configuration.basic.email',
      label: 'configuration.basic.email',
      name: 'email',
      type: 'email',
    },
  },
  {
    type: 'input',
    section: 'other',
    props: {
      placeholder: 'configuration.basic.www',
      label: 'configuration.basic.www',
      name: 'www',
    },
  },
  {
    type: 'input',
    section: 'other',
    props: {
      placeholder: 'configuration.basic.contactPerson',
      label: 'configuration.basic.contactPerson',
      name: 'contactPerson',
    },
  },
  {
    type: 'input',
    section: 'other',
    props: {
      placeholder: 'configuration.basic.position',
      label: 'configuration.basic.position',
      name: 'position',
    },
  },
  {
    type: 'input',
    section: 'other',
    props: {
      placeholder: 'configuration.basic.licenseNumber',
      label: 'configuration.basic.licenseNumber',
      name: 'licenseNumber',
    },
  },
]

export const settingsDataCompany = settingsData.filter((field) => field.section === 'company')
export const settingsDataAddress = settingsData.filter((field) => field.section === 'address')
export const settingsDataOther = settingsData.filter((field) => field.section === 'other')
